import { createActions } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions({
    // view order type
    requestViewOrderType: ['id'],
    viewOrderTypeSucceeded: ['data'],
    viewOrderTypeFailed: ['error'],

    // clear state
    clearOrderTypeViewState: null,
});

export default {
    // view order type
    [types.REQUEST_VIEW_ORDER_TYPE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            loading: true,
            error: null,
        },
    }),
    [types.VIEW_ORDER_TYPE_SUCCEEDED]: (state, { data }) => ({
        ...state,
        view: {
            ...state.view,
            typeDetails: data,
            loading: false,
        },
    }),
    [types.VIEW_ORDER_TYPE_FAILED]: (state, { error }) => ({
        ...state,
        view: {
            ...state.view,
            loading: false,
            error,
        },
    }),

    // clear state
    [types.CLEAR_ORDER_TYPE_VIEW_STATE]: (state) => ({
        ...state,
        view: {
            ...state.view,
            typeDetails: null,
        },
    }),
}
